/**
 * Copyright (C) Sitevision AB 2002-2026, all rights reserved
 */

import events from 'events';

export default Object.assign({}, events);
